var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C13.5938 10 10 13.5938 10 18V74C10 78.4062 13.5938 82 18 82H74C78.4062 82 82 78.4062 82 74V18C82 13.5938 78.4062 10 74 10H18ZM23.625 28.75H34C43.2031 28.75 44.75 34.4063 44.75 38C44.75 43.2031 41.1719 44.8438 40.375 45.25C41.1719 45.6563 45.25 46.75 45.25 52.75C45.6563 59.9531 41.1563 62.75 34.75 62.75H23.625V28.75ZM51.625 28.75H66.375V32.75H51.625V28.75ZM30.375 34.375V42.75H34C36.4063 42.75 38 41.9531 38 38.75C38 35.9531 36.7969 34.375 34 34.375H30.375ZM60.375 37.25C65.9688 37.25 70 40.4219 70 49.625V52.375H56.375C56.375 53.5781 56.4531 58 61.25 58C64.4531 58 65.9531 56.4219 66.75 55.625L69.625 59.625C69.2188 60.0313 66.4531 63.25 61.25 63.25C55.25 63.25 50.375 60.0312 50.375 51.625V49.625C50.375 40.4219 55.1719 37.25 60.375 37.25ZM59.625 42.375C58.4219 42.375 56 42.8281 56 47.625H62.75C62.75 47.625 63.625 42.375 59.625 42.375ZM30.375 48V57.25H34.75C37.1563 57.25 38.375 55.5469 38.375 52.75C38.7813 49.5469 37.6563 48 35.25 48H30.375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.3cdf09c635cbadc297b7faf3529ecea2.svg";
export { ForwardRef as ReactComponent };